import React from 'react';
import Icon from '../../../components/AppIcon';

const ReportMetadata = ({ metadata }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const metadataItems = [
    {
      icon: 'Calendar',
      label: 'Generado',
      value: formatDate(metadata?.generatedAt),
      color: 'var(--color-primary)'
    },
    {
      icon: 'Users',
      label: 'Agentes Contribuyentes',
      value: metadata?.contributingAgents?.join(', '),
      color: 'var(--color-accent)'
    },
    {
      icon: 'FolderTree',
      label: 'Proyecto',
      value: metadata?.projectName,
      color: 'var(--color-success)'
    },
    {
      icon: 'FileText',
      label: 'Versión',
      value: metadata?.version,
      color: 'var(--color-warning)'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
          <Icon name="Info" size={20} color="var(--color-primary)" />
        </div>
        <h2 className="text-lg font-semibold font-mono">Metadatos del Informe</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {metadataItems?.map((item, index) => (
          <div key={index} className="flex items-start gap-3 p-3 bg-background rounded-md border border-border">
            <div
              className="flex items-center justify-center w-8 h-8 rounded-lg flex-shrink-0"
              style={{ backgroundColor: `${item?.color}15` }}
            >
              <Icon name={item?.icon} size={16} color={item?.color} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs text-muted-foreground caption mb-1">{item?.label}</p>
              <p className="text-sm font-medium text-foreground truncate">{item?.value}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReportMetadata;